import { OPTION_SIZE, OPTION_TYPES } from '@nexxt/common/types';

export const optionDisplayedInRow = [
    { label: 'auto', value: 0 },
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
    { label: '5', value: 5 },
    { label: '6', value: 6 },
    { label: '7', value: 7 },
    { label: '8', value: 8 },
    { label: '9', value: 9 },
    { label: '10', value: 10 },
    { label: '11', value: 11 },
    { label: '12', value: 12 }
];

export const optionType = [
    { label: 'Text', value: OPTION_TYPES.TEXT_ONLY },
    { label: 'Image', value: OPTION_TYPES.IMAGE_ONLY },
    { label: 'Both', value: OPTION_TYPES.IMAGE_AND_TEXT }
];

export const optionSize = [
    { label: 'Auto', value: OPTION_SIZE.AUTO },
    { label: 'Small', value: OPTION_SIZE.SMALL },
    { label: 'Medium', value: OPTION_SIZE.MEDIUM },
    { label: 'Large', value: OPTION_SIZE.LARGE },
    { label: 'XL', value: OPTION_SIZE.XL },
    { label: 'Full', value: OPTION_SIZE.FULL }
];

export const optionSizeWithIcon = [
    { label: 'Icon', value: OPTION_SIZE.ICON },
    { label: 'Small', value: OPTION_SIZE.SMALL },
    { label: 'Medium', value: OPTION_SIZE.MEDIUM },
    { label: 'Large', value: OPTION_SIZE.LARGE },
    { label: 'Full', value: OPTION_SIZE.FULL }
];

export const popupCardType = [
    { label: 'Text', value: 'textOnly' },
    { label: 'Image', value: 'imageOnly' }
];

export const alignOptions = [
    { label: 'Left', value: 'left' },
    { label: 'Right', value: 'right' },
    { label: 'Center', value: 'center' }
];

export const imageDisplay = [
    { label: 'Square', value: 'square' },
    { label: 'Circle', value: 'circle' }
];

export const optionTypeMapping = {
    textOnly: 'Text',
    imageOnly: 'Image',
    imageAndText: 'Image and text'
};

export const tradeoffOptionMapping = {
    textOnly: 'Text',
    imageOnly: 'Image'
};

export const popupCardOptionMapping = {
    textOnly: 'Text',
    imageOnly: 'Image'
};

export const imgDisplayMapping = {
    circle: 'Circle',
    square: 'Square'
};

export const oAlignMapping = {
    left: 'Left',
    right: 'Right',
    center: 'Center'
};

export const optionTypeMappingObject = {
    textOnly: { label: 'Text', value: 'textOnly' },
    imageOnly: { label: 'Image', value: 'imageOnly' },
    imageAndText: { label: 'Image and text', value: 'imageAndText' }
};

export function getOptionObject(value) {
    return (
        optionTypeMappingObject[value] || optionTypeMappingObject['textOnly']
    );
}
